import React,{ useState} from 'react';
import{
    CheckBoxContainer,
} from './index.styled.jsx';
import Checkbox from 'src/common/refactoredComponents/checkbox/Checkbox';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
import { logErrorToConsole } from 'src/utils/util';

const TemplateCheckBox = ({
    item,
    checkBoxDetails,
    productWithIsPlaceHolderSet,
    isAddToBundle,
    isCondensedView,
}) => {
    const [checkBoxInfo, setCheckBoxInfo] = useState({});
    useEffectWithErrorLogging(() => {
        setCheckBoxInfo({
            ...checkBoxDetails,
        });
        return () => {};
    }, [checkBoxDetails]);
    return (
        <CheckBoxContainer
            isAddToBundle={isAddToBundle}
            isCondensedView={isCondensedView}
        >
            <Checkbox
                name={checkBoxInfo.name}
                onCheckboxSelectionChange={() => {
                    try {
                        checkBoxInfo.checked = !checkBoxInfo.checked;
                        setCheckBoxInfo({ ...checkBoxInfo });
                        checkBoxDetails.onChange();
                    } catch (error) {
                        logErrorToConsole(error);
                    }
                }}
                checked={checkBoxInfo.checked}
                id={checkBoxInfo.id}
                disabled={productWithIsPlaceHolderSet?.some(
                    (data) => data.cfn === item.cfn
                )}
                background={'none'}
                checkboxBorder={'1.5px solid #555555'}
                alignItemDirection={'center'}
                hoverEffect={'false'}
                disableFocusEffect={'true'}
            />
        </CheckBoxContainer>
    );
};

export default TemplateCheckBox;